import React, { Suspense, lazy } from 'react';

/**
 * Lazy boundary for the growth chart (2026-07 bundle-reduction follow-up).
 *
 * The implementation (GrowthChartImpl) pulls in recharts, and recharts v3
 * transitively bundles the entire redux toolkit + react-redux + es-toolkit +
 * a stack of d3 modules — ~110 kB gzip. GrowthChart is only ever shown inside
 * the student details modal and the per-student report, never on the two
 * LCP-critical first-paint screens (dashboard, /assessment). Making it a lazy
 * boundary moves that whole subtree into its own async chunk so it is fetched
 * only when a chart is actually rendered, and keeps the eager main bundle free
 * of recharts. The public API is unchanged: `<GrowthChart assessments={…} />`.
 *
 * The fallback holds the chart's exact box (height 300, same margins) so there
 * is no layout shift while the chunk loads.
 */
const GrowthChartImpl = lazy(() => import('./GrowthChartImpl'));

function GrowthChartFallback() {
  return (
    <div
      className="growth-chart-container"
      style={{
        width: '100%',
        height: 300,
        backgroundColor: '#fff',
        padding: '15px',
        borderRadius: '12px',
        boxShadow: 'var(--shadow-sm)',
        marginTop: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#94a3b8',
        fontStyle: 'italic',
      }}
    >
      Loading chart…
    </div>
  );
}

export default function GrowthChart(props) {
  return (
    <Suspense fallback={<GrowthChartFallback />}>
      <GrowthChartImpl {...props} />
    </Suspense>
  );
}
